const NUMBER_LOCALE = 'de-DE'

export const isFiniteNumber = (value: number | null | undefined): value is number =>
  typeof value === 'number' && Number.isFinite(value)

const formatFixedNumberValue = (value: number, fractionDigits: number): string =>
  new Intl.NumberFormat(NUMBER_LOCALE, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)

const formatCompactFinancialValue = (value: number): string => {
  if (value >= 1_000_000) {
    return `${formatFixedNumberValue(value / 1_000_000, 2)}M`
  }

  if (value >= 1_000) {
    return `${formatFixedNumberValue(value / 1_000, 2)}K`
  }

  return formatFixedNumberValue(value, 2)
}

export const formatFixedNumber = (
  value: number | null | undefined,
  fractionDigits: number
): string | null => {
  if (!isFiniteNumber(value)) {
    return null
  }

  return formatFixedNumberValue(value, fractionDigits)
}

export const formatFinancialNumber = (value: number | null | undefined): string => {
  if (!isFiniteNumber(value)) {
    return '—'
  }

  const sign = value < 0 ? '-' : ''
  return `${sign}${formatCompactFinancialValue(Math.abs(value))}`
}

export const formatFinancialCurrency = (value: number | null | undefined): string => {
  if (!isFiniteNumber(value)) {
    return '—'
  }

  const sign = value < 0 ? '-' : ''
  return `${sign}$ ${formatCompactFinancialValue(Math.abs(value))}`
}

export const formatSobValue = (value: number | null | undefined): string | null =>
  formatFixedNumber(value, 1)
